import axios from 'axios'
import { handleApiError } from '@/utils/apiHelpers'

export default {
    getUserTasks({ commit }, payload = {
        paginate: '',
        query: ''}) {
        const paginate = payload.paginate,
            query = payload.query

        commit('GET_USER_TASKS_REQUEST')

        return axios
            .get(`/user-tasks/user-tasks${paginate}${query}`)
            .then(response => {
                commit('GET_USER_TASKS_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('GET_USER_TASKS_FAILURE')
                handleApiError(error, 'Pobranie listy zadań nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getUserTask(context, userTaskId) {
        return axios
            .get(`/user-tasks/user-tasks/${userTaskId}`)
            .then(response => {

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, `Pobranie danych do zadania ${userTaskId} nie powiodło się.`)

                return Promise.reject(error)
            })
    },
    createUserTask({ commit }, userTaskData) {
        return axios
            .post('/user-tasks/user-tasks', userTaskData)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Zadanie zostało dodane.'
                }, {root: true})

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Dodanie zadania nie powiodło się.')

                return Promise.reject(error)
            })
    },
    updateUserTask(context, userTaskData) {
        return axios
            .put(`/user-tasks/user-tasks/${userTaskData.id}`, userTaskData)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Zapis zadania nie powiódł się.')

                return Promise.reject(error)
            })
    },
    deleteUserTask({ commit }, userTaskId) {
        return axios
            .delete(`/user-tasks/user-tasks/${userTaskId}`)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Zadanie zostało usunięte.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Usunięcie zadania nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getUserTaskStatuses({ commit }) {
        return axios
            .get('/user-tasks/dicts/user-task-statuses')
            .then(response => {
                commit('GET_USER_TASK_STATUSES_SUCCESS', response.data.results)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie statusów nie powiodło się.')

                return Promise.reject(error)
            })
    },
    setUserTasksFilters({ commit }, filters) {
        commit('SET_USER_TASK_FILTERS', filters)
    },
    clearUserTasksFilters({ commit }) {
        commit('CLEAR_USER_TASK_FILTERS')
    },
}